import * as React from 'react';
import { useSelector } from 'react-redux';

import { AdfoxBanner } from '../../../components/AdfoxBanner';
import { selectIsAgent } from '../../../selectors';
import { useAdfoxPuids } from '../hooks/useAdfoxPuids';

const ADFOX_PARAMETERS = {
  p1: 'cwhux',
  p2: 'hxqi',
};

export function AsideMortgageBannerContainer() {
  const isAgent = useSelector(selectIsAgent);
  const adfoxPuids = useAdfoxPuids();
  const adfoxParameters = React.useMemo(
    () => ({
      ...adfoxPuids,
      ...ADFOX_PARAMETERS,
    }),
    [adfoxPuids],
  );

  return (
    <AdfoxBanner
      disableYan={isAgent}
      hideable={true}
      minHeight="100px"
      minWidth="468px"
      analyticsEventName="AsideMortgageBanner"
      params={adfoxParameters}
    />
  );
}
